import { createFileRoute } from '@tanstack/react-router';

import WpSiteControlResetPassword from 'component/view/Auth/WpSiteControlResetPassword';

interface ResetPasswordSearch {
  token?: string;
  email?: string;
  user_id?: string;
}

export const Route = createFileRoute('/reset-password')({
  validateSearch: (search: Record<string, unknown>): ResetPasswordSearch => ({
    token: typeof search.token === 'string' ? search.token : undefined,
    email: typeof search.email === 'string' ? search.email : undefined,
    user_id: search.user_id != null ? String(search.user_id) : undefined,
  }),
  component: WpSiteControlResetPassword,
});
